export const API_BASE_URL = process.env.REACT_APP_API_URL;

export const PROCESS_ENDPOINTS = {
  GET_PROCESSES: `${API_BASE_URL}/Reference/GetProcesses`,
  CREATE_PROCESS: `${API_BASE_URL}/Reference/SaveProcess`,
  GET_ACTIVITIES_BY_PROCESS: `${API_BASE_URL}/Reference/GetActivitiesByProcess`,
  GET_BEHAVIOUR_TYPES: `${API_BASE_URL}/Reference/GetBehaviourTypes`,
};

export const REFERENCE_ENDPOINTS = {
  GET_BEHAVIOUR_TYPES: `${API_BASE_URL}/Reference/GetBehaviourTypes`,
  SAVE_ACTIVITY: `${API_BASE_URL}/Reference/SaveActivity`,
};

export const JOB_ENDPOINTS = {
  CREATE_JOB: `${API_BASE_URL}/Job/CreateJob`,
};
